<template>
  <!-- eslint-disable vue/no-v-html -->
  <div class="ql-editor" v-html="content">
  </div>
</template>
<script>
import { defineComponent, ref, onMounted } from '@vue/composition-api';
export default defineComponent({
  setup(props, { root }) {
    const content = ref('');
    const name = root.$route.name;
    const url = 'https://gth5.kuaiduizuoye.com/perform/privacy/getPrivacyByCode';

    onMounted(async () => {
      try {
        const { data } = await root.$http.get(url, { code: `kd-${name}` });
        content.value = data.content || '';
      } catch (error) {
        console.log(error);
      }
    })

    return {
      content
    }
  }
});
</script>
<style scoped>
@import './quill.snow.css';
.ql-editor {
  padding-bottom: 50px;
}
</style>
